import { Box, Text } from '@cmpsr/components';
import React from 'react';

/**
 * Displays the "Loading your free Preliminary Risk Assessment" message.
 */
const LoadingMessage: React.FC = () => {
  return (
    <Box mx={{ base: 'spacer-2', lg: 'spacer-4' }} textAlign="center">
      <Text color="white" textAlign="center" mb="spacer-2" variant={{ lg: 'text-header-XL', base: 'text-header-XL' }}>
        Analyzing your preliminary results
      </Text>
    </Box>
  );
};

export default LoadingMessage;
